import HeatmapsUpsellModal from './HeatmapsUpsellModal';

export default HeatmapsUpsellModal;
